export const includedKeys = ['name', 'wa_category', 'wa_sender_code', 'text', 'status', 'create_date'];

export const WA_TEMPLATE_CATEGORIES = {
    MARKETING: 'Marketing',
    UTILITY: 'Utility',
    AUTHENTICATION: 'Authentication',
};

export const WA_OPTIONS = Object.entries(WA_TEMPLATE_CATEGORIES).map(([key, label]) => {
    return { value: key, label: label as string };
});

export const WHATSAPP_BUTTONS = [
    {
        label: 'Quick Reply',
        value: 'quick_reply',
    },
    {
        label: 'Call to Action',
        value: 'call_to_action',
    },
];

export const WHATS_APP_TTL_TYPE = {
    '30': '30 seconds',
    '60': '1 minute',
    '120': '2 minutes',
    '180': '3 minutes',
    '300': '5 minutes',
    '600': '10 minutes',
    '900': '15 minutes',
};

export const WHATS_APP_TTL_OPTIONS: any = Object.entries(WHATS_APP_TTL_TYPE).map(([key, label]) => {
    return { value: key, label: label as string };
});

export const actionAttribute = 'data-action-id';
